module.exports = __webpack_public_path__ + "static/media/minus.9d1af844.png";